const INITIAL_BLOCKE = {
  list: [],
  loading: false,
};
  
export default (state = INITIAL_BLOCKE, action) => {
  switch (action.type) {
    case 'GET_HOME_BLOCK_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'GET_HOME_BLOCK_LIST_SUCCESS':
      return {
        loading: false,
        list: action.payload,
      };
    case 'GET_HOME_BLOCK_LIST_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'CREATE_HOME_BLOCK_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CREATE_HOME_BLOCK_SUCCESS':
      return {
        list: [...state.list, action.payload.data],
        loading: false,
      };
    case 'CREATE_HOME_BLOCK_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'EDIT_HOME_BLOCK_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'EDIT_HOME_BLOCK_SUCCESS':
      return {
        list: [...state.list.filter(document => document._id !== action.payload._id), action.payload.data],
        loading: false,
      };
    case 'EDIT_HOME_BLOCK_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'DELETE_HOME_BLOCK_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'DELETE_HOME_BLOCK_SUCCESS':
      return {
        list: [...state.list.filter(document => document._id !== action.payload._id)],
        loading: false,
      };
    case 'DELETE_HOME_BLOCK_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'LOGOUT':
      return INITIAL_BLOCKE;
    default:
      return state;
  }
};
  



// WEBPACK FOOTER //
// ./src/reducers/home-block.js